import { render, staticRenderFns } from "./FooterCom.vue?vue&type=template&id=f876b3f6&scoped=true&"
import script from "./FooterCom.vue?vue&type=script&lang=js&"
export * from "./FooterCom.vue?vue&type=script&lang=js&"
import style0 from "./FooterCom.vue?vue&type=style&index=0&id=f876b3f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f876b3f6",
  null
  
)

export default component.exports